var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('v-btn',{staticClass:"ma-2",attrs:{"outlined":"","large":"","color":"green","to":"/"}},[_c('v-icon',{attrs:{"dark":"","left":""}},[_vm._v("mdi-arrow-left-circle")]),_vm._v("Back ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }